<template>
  <div class="newsletter">
    <v-dialog
      v-model="success"
      width="350"
      scroll-strategy="none"
      target="parent"
      transition="none"
    >
      <div class="dialog-custom">
        <p>Formulář byl úspěšně odeslán. Děkujeme za přihlášení odběru novinek z naší školy.</p>
        <div class="d-flex justify-center">
          <v-btn
            variant="flat"
            color="#283583"
            class="mt-5"
            @click="closeDialog"
          >
            Pokračovat
          </v-btn>
        </div>
      </div>
    </v-dialog>
    <div>
      <h2>Klub přátel SOŠLP</h2>
      <small>Zde se můžete přihlásit k odběru novinek. Poskytnuté e-mailové adresy jsou zpracovávány pouze za účelem rozesílání novinek a po dobu přihlášení k jejich odběru. Kdykoliv odhlásit se můžete <a href="/newsletter">zde</a>.</small>
    </div>
    <v-form @submit.prevent="submitNewsletter">

      <v-select
        v-model="gender"
        :items="genderItems"
        item-title="text"
        item-value="value"
        label="Oslovení"
        variant="solo"
        density="compact"
        bg-color="#e2e9ff"
        :error-messages="getViolation('gender')"
      ></v-select>

      <v-text-field
        v-model="name"
        type="email"
        :error-messages="getViolation('name')"
        variant="solo"
        density="compact"
        bg-color="#e2e9ff"
        label="Jméno"
      ></v-text-field>

      <v-text-field
        v-model="email"
        type="email"
        :error-messages="getViolation('email')"
        variant="solo"
        density="compact"
        bg-color="#e2e9ff"
        label="Zadejte Váš e-mail"
      ></v-text-field>

      <v-btn
        variant="flat"
        type="submit"
        color="#fff"
        :loading="loading"
      >Přihlásit se</v-btn>
    </v-form>
  </div>
</template>

<script setup>
import Axios from '../ajax'
import Qs from 'qs'
import { ref } from 'vue'
import { useErrorHandler } from '../composables/useErrorHandler'

const loading = ref(false)
const name = ref('')
const email = ref('')
const success = ref(false)

const { getViolation, clearViolations, buildViolations } = useErrorHandler()

const closeDialog = () => {
  success.value = false
  email.value = ''
  name.value = ''
  gender.value = ''
}

const submitNewsletter = async () => {
  try {
    loading.value = true
    clearViolations()
    const response = await Axios.post('/prihlasit-newsletter.json', Qs.stringify({
      email: email.value,
      name: name.value,
      gender: gender.value
    }))
    success.value = true
    console.log(response)
  } catch (error) {
    buildViolations(error.response)
    console.error(error)
  } finally {
    loading.value = false
  }
}

const gender = ref('male')
const genderItems = ref([
  { value: 'male', text: 'Pan' },
  { value: 'female', text: 'Paní' }
])

</script>
